<template>
    <ClModal
      v-model="showModal"
      class='rma-number'
      width="400px"
    >
        <template #activator="{ attrs, on }">
            <slot
                :attrs="attrs"
                :on="{ ...on, click: handleClick }"
            />
        </template>
        <v-card>
            <v-card-title
                class="rma-number__title headline"
            >
                Set RMA Number
            </v-card-title>
            <ClButton
                icon
                aria-label="Close Modal"
                color="white"
                class="rma-number__close-button"
                @click="showModal = false"
            >
                <v-icon>mdi-close</v-icon>
            </ClButton>
            <v-container class="rma-number__content">
                <v-row>
                    <v-col cols="12">
                        <ClInput
                            v-model="localRMANumber"
                            type="text"
                            label="RMA Number"
                        />
                    </v-col>
                    <v-col cols="12">
                        <ClInput
                            v-model="localReason"
                            type="text"
                            label="Reason"
                        />
                    </v-col>
                </v-row>
            </v-container>
            <v-card-actions class="rma-number__actions">
                <v-spacer />
                <ClButton
                    type="secondary"
                    :rounded="false"
                    @click="showModal = false"
                >
                    Cancel
                </ClButton>
                <ClButton
                    type="primary"
                    :rounded="false"
                    @click="setButtonHandler()"
                >
                    Set & Save
                </ClButton>
            </v-card-actions>
        </v-card>
    </ClModal>
</template>

<script>
/**
 * @emits 'update'
 */
export default {
    name: 'ModalRMANumber',
    props: {
        rmaNumber: {
            type: String,
            required: false,
            default: '',
        },
        reason: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            localRMANumber: '',
            localReason: '',
            showModal: false,
        };
    },
    watch: {
        showModal: {
            handler() {
                if ( this.showModal ) {
                    this.localRMANumber = this.rmaNumber;
                    this.localReason = this.reason;
                } else {
                    this.localRMANumber = '';
                    this.localReason = '';
                }
            },
            immediate: true,
        },
    },
    methods: {
        setButtonHandler() {
            this.$emit( 'update', {
                rmaNumber: this.localRMANumber,
                reason: this.localReason,
            } );
            this.showModal = false;
        },
        handleClick() {
            this.$emit( 'activator:click', this.openModal );
        },
        openModal() {
            this.showModal = true;
        },
    },
};
</script>

<style lang="scss" scoped>
    .rma-number {
        &__content {
            padding: 1.5rem 1rem 1rem;
        }
        &__title{
            background-color: var(--v-primary-base);
            color: white;
            position: relative
        }
        &__close-button {
            position: absolute;
            top: 11px;
            right: 16px;
        }
        &__actions {
            padding-bottom: 1rem;
        }
    }
</style>
